<template>
  <b-card>
    <!-- table -->
    <vue-good-table
      ref="my-table-user"
      :columns="columns"
      :rows="rows"
      :rtl="direction"
      :line-numbers="true"
      :search-options="{
        enabled: false,
        externalQuery: searchTerm,
      }"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: false, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
    >
      <template slot="table-row" slot-scope="props">

        <span v-if="props.column.field === 'fullname'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.titleStr }}{{ props.row.fname }} {{ props.row.lname }}
          </span>
        </span>

        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              class="text-body align-middle mr-25"
              @click="onCancelBtnClicked(props.row)"
            >
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span class="align-middle">ถอดสิทธิ์การเป็นเลขา</span> 
            </b-button>
          </span>
        </span>

      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              แสดง 1 ถึง
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '25', '50', '100']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> จาก {{ props.total }} รายการ </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>

    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BButton,
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BCardHeader,
  BCardBody,
  BFormCheckboxGroup,
  BFormCheckbox, // ,BRow, BCol, BFormTextarea, BFormRadio, BTab, BTabs,
  BOverlay,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import Ripple from "vue-ripple-directive";
import { codeBasic } from "@/views/table/vue-good-table/code";
import store from "@/store/index";

import * as departmentRoleStore from "@/store/api/role/departmentRole.js";

export default {
  directives: {
    Ripple,
  },
  components: {
    VueGoodTable,
    BButton,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BCard,
    BFormCheckbox,
    BFormCheckboxGroup,
    BOverlay,
  },
  props: {},
  setup(props) {
    // return {
    //   rows: props.users,
    // };
  },
  data() {
    return {
      rows: [],
      pageLength: 10,
      dir: false,
      codeBasic,
      columns: [
        {
          label: "ชื่อ - นามสกุล",
          field: "fullname",
        },
        {
          label: "จัดการ",
          field: "action",
        },
      ],
      secretaryNameList: [],
      searchTerm: "",
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],
    };
  },
  computed: {
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        Current: "light-primary",
        Professional: "light-success",
        Rejected: "light-danger",
        Resigned: "light-warning",
        Applied: "light-info",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
  },
  created() {
  },
  methods: {
    onSearchSubmit(params) {
      console.log("onSearchSubmit", params);
      this.$emit("handleOverlay", true);

      const _this = this;
      departmentRoleStore
        .getSecretary(params)
        .then(function(response) {
          // handle success
          console.log("then", response);
          _this.rows = response.data.data;
          console.log("result", _this.rows);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    },
    onCancelBtnClicked(params) {   
      console.log("onCancelBtnClicked", params);
      this.$emit("handleOverlay", true);

      const _this = this;
      const whereDelete = {
        userDepartmentRoleId: params.userDepartmentRoleId,
        userId: params.userId,
      };

      const dataSearch = {
        userDepartmentRoleID : params.userDepartmentRoleId,
        page : 1,
        takeItems : 10,
      };

      console.log("dataDelete", whereDelete);
      console.log("dataSearch", dataSearch);

      departmentRoleStore
        .postSecretaryDelete(whereDelete.userDepartmentRoleId, whereDelete.userId)
        .then(function(response) {
          // handle success
          console.log("postSecretaryDelete");
          _this.onSearchSubmit(dataSearch);
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        })
        .then(function() {
          // always executed
          console.log("GET");
          _this.$emit("handleOverlay", false);
        });
    }
  },
};
</script>